import React, { FC } from 'react'

/**
 * 进度条组件
 */
// eslint-disable-next-line import/prefer-default-export
export const ProgressBar: FC<{
  percent?: number
  className?: string
  barColor?: string
  bgColor?: string
}> = ({
  percent = 0,
  className = '',
  barColor = 'black',
  bgColor = '#e5e5e5',
}) => (
  <div
    className={className}
    style={{
      cursor: 'none',
      background: `linear-gradient(to right, ${barColor} ${percent}%, ${bgColor} ${percent}%)`,
    }}
  />
)
